import { CommonModule } from "@angular/common";
import { Component, NgModule, ViewChild } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { DxFormComponent, DxFormModule } from "devextreme-angular/ui/form";
import { DxButtonModule } from "devextreme-angular/ui/button";
import { DxLoadIndicatorModule } from "devextreme-angular/ui/load-indicator";
import notify from "devextreme/ui/notify";
import { AuthService } from "../../services";
import { DxTextBoxModule } from "devextreme-angular";
import { UserLoginRequest } from "../../../classes/infrastructure/request_response/userloginrequest";
import { isNullOrUndefined } from "../../../../tools";
import { UIUtils } from "../../../services/uiutils.service";
import { SessionValues } from "../../../services/sessionvalues.service";
import { ServerCommunicatorService } from "../../../services/server-communicator.service";
import { AppStateManageService } from "../../../services/app-state-manage.service";
import { FilterDataUPTOLevelsService } from "../../../services/hierarchy.service";
import { PasswordFlowMode } from "../../../services/passwordflowmode";
import { HierarchyFilterService } from "../../../services/hierarchyfilterwithmonthyearlevel.service";
import { SidebarMenuStateService } from "../../../services/sidebarmenustateservice";
import { Languages } from "../../../classes/infrastructure/enums";
import { LanguageService } from "../../../services/language.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ProfileStateService } from "../../../services/profilestate.service";
import { ThemeSwitcherComponent } from "../theme-switcher/theme-switcher.component";

@Component({
  selector: "app-login-form",
  templateUrl: "./login-form.component.html",
  styleUrls: ["./login-form.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxTextBoxModule,
    TranslateModule,
    ThemeSwitcherComponent,
  ],
})
export class LoginFormComponent {
  @ViewChild("loginForm", { static: false }) loginFormRef!: DxFormComponent;

  loading = false;
  formData: any = {
    email: "",         // for live
    password: "",     // for live

    // email: "tulasi.l@velocetechinsights.com",
    // email: "guest@gmail.com",
    // email: "Jayshri12@gmail.com",
    // email: "9096693508",
    // email: "7218508996",
    // email: "shubhangi1258@gmail.com",
    // password: "Tulasi@2025",
    // password: "7218508996 ",  
    // password: "123456",  
  };
  useSubmitBehavior: boolean = true;

  selectedLanguage: Languages = Languages.English;
  selectedLanguages: number = 0;

  constructor(
    private authService: AuthService,
    private router: Router,
    private uiUtils: UIUtils,
    private servercommunicator: ServerCommunicatorService,
    private appStateManage: AppStateManageService,
    public FilterStateService: FilterDataUPTOLevelsService,
    public FilterStateServiceMonthWise: HierarchyFilterService,
    private sidebarMenuState: SidebarMenuStateService,
    public langService: LanguageService,
  ) { }

  passwordMode = "password";

  togglePasswordVisibility = () => {
    this.passwordMode = this.passwordMode === "text" ? "password" : "text";
  };

  // Enter pressed inside the username field: move focus to password,
  // don't submit yet.
  onUsernameEnterKey = (e: any) => {
    const passwordEditor = this.loginFormRef?.instance.getEditor("password");
    if (passwordEditor) {
      passwordEditor.focus();
    }
  };

  // Enter pressed inside the password field: submit, same as clicking
  // the Login button.
  onPasswordEnterKey = (e: any) => {
    this.onSubmit(e?.event);
  };

  async onSubmit(e: Event) {
    e.preventDefault();
    this.loading = true;
    if (this.formData.email.trim() == "") {
      const msg =
        this.langService.currentLang === "mr"
          ? "कृपया ईमेल आयडी टाका"
          : "Please Enter Email ID";

      this.uiUtils.showErrorToster(msg);
      this.loading = false;
      return;
    }
    if (this.formData.password.trim() == "") {
      const msg =
        this.langService.currentLang === "mr"
          ? "कृपया पासवर्ड टाका"
          : "Please Enter Password";

      this.uiUtils.showErrorToster(msg);
      this.loading = false;
      return;
    }
    let loginRequest = new UserLoginRequest();
    const saved = (sessionStorage.getItem("app_lang") as "en" | "mr") || "en";
    if (saved === "en") this.selectedLanguages = 100;
    else if (saved === "mr") this.selectedLanguages = 200;
    loginRequest.user_id = this.formData.email;
    loginRequest.password = this.formData.password;
    loginRequest.language_preference = this.selectedLanguages;
    const result = await this.authService.logIn(loginRequest);
    console.log("result :", result);

    if (!result.successful) {
      this.loading = false;
      // this.uiUtils.showErrorToster(result.message);
      this.uiUtils.handleError("Error", result.message);
      // this.uiUtils.showErrorMessageForPasswordExpire(
      //   'Password Expired',
      //   'Please change your password to continue.'
      // );
      return;
    }

    this.sidebarMenuState.setLoginUserData(result);

    await this.getValidateMenuStateData();

    // set all sidebar menu item
    const validMenuItemList = result.ValidMenuItemIds2 ?? [];

    // optional persistence
    sessionStorage.setItem(
      "menuPermissions",
      JSON.stringify(validMenuItemList),
    );
    if (result.LoginUserRef) {
      console.log("result :", result);
      this.appStateManage.setLoginToken(result.LoginUserToken);
      this.appStateManage.setUserDisplayName(result.UserDisplayName);

      this.appStateManage.setLoginUserRef(result.LoginUserRef);

      if (result.FinancialYearResponses.length == 1) {
        this.appStateManage.StorageKey.setItem(
          "ToDate",
          result.FinancialYearResponses[0].to_date.toString(),
        );
      } else if (result.FinancialYearResponses.length == 2) {
        if (
          result.FinancialYearResponses[0].ToYear >
          result.FinancialYearResponses[1].ToYear
        ) {
          this.appStateManage.StorageKey.setItem(
            "ToDate",
            result.FinancialYearResponses[0].to_date.toString(),
          );
        } else {
          this.appStateManage.StorageKey.setItem(
            "ToDate",
            result.FinancialYearResponses[1].to_date.toString(),
          );
        }
      }
    }
    if (result.FinancialYearResponses) {
      this.appStateManage.StorageKey.setItem(
        "FinancialYearResponses",
        JSON.stringify(result.FinancialYearResponses),
      );
    }
    if (result.Role) {
      this.FilterStateService.resetFilters(); // We can reset all service states //
      this.FilterStateServiceMonthWise.resetFilters(); // We can reset all service states //
      this.appStateManage.setRole(result.Role);
      this.appStateManage.setRoleName(result.RoleName);
    }
    if (result.PostRef) {
      this.appStateManage.setPostRef(result.PostRef);
    }
    if (result.UnderSupervisionPostRef) {
      this.appStateManage.setUnderSupervisionPostRef(
        result.UnderSupervisionPostRef,
      );
    }
    if (result.Months) {
      this.appStateManage.setMonths(result.Months);
    }

    if (result.FirstLoginCompleted == 0) {
      this.router.navigate(["/Change_Password"]);
    } else {
      await this.router.navigate(["/home"]);
    }
  }

  NavigateForgotPassword = () => {
    this.appStateManage.setPasswordFlowMode(PasswordFlowMode.FORGOT);
    this.router.navigate(["/forgot-password"]);
  };

  getValidateMenuStateData = async () => {
    const menuRes = await this.servercommunicator.GetValidMenuItemList();
    console.log("menuRes :", menuRes);
    this.sidebarMenuState.setMenuOnly(menuRes.ObjectTag);
    this.appStateManage.setProfileImage(menuRes.ObjectTag.profile_pic_path);
  };
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxButtonModule,
    DxTextBoxModule,
    TranslateModule,
    LoginFormComponent,
  ],
  exports: [LoginFormComponent],
})
export class LoginFormModule { }
